import React from "react";
import PropTypes from "prop-types";
import Banner from "@/bit/components/components.cms-block.cms-banner";
import BuyBox from "../cms-buy-box-list";
import Characteristics from "../cms-characteristic-list";
import Alert from "../cms-alert";
import PageSelector from "../cms-page-selector";

/**
 * Componente que permite crear la fila de las fichas donde aparecen Banner, Buybox y CharacteristicsList
 */
function CmsProductInfo(props) {
  const {
    loaded,
    cmsHandler = null,
    blockName,
    alias,
    CmsAddElement,
    CmsEditableGroupIcons,
  } = props;
  const cssProductInfo = "ProductInfo";
  const buyBoxProps = props["cms-ml-buy-box-1"];
  const alertProps = props["cms-ml-alert-1"];

  const characteristicsProps = props["cms-ml-characteristics-1"] || {};
  const selectorProps = props["cms-ml-page-selector-1"];
  const bannerProps = props["cms-ml-product-banner-1"];

  const thereIsCharacs =
    characteristicsProps?.["cms-ml-single-characteristic-list"]?.length > 0;
  const thereIsAlert =
    characteristicsProps?.["cms-ml-single-characteristic-list"]?.length > 0;
  const thereIsPageSelector =
    selectorProps?.["cms-ml-single-selector-list-1"]?.length > 0 ||
    selectorProps?.["cms-ml-single-selector-list-2"]?.length > 0;
  const thereIsNOBuyBox =
    !buyBoxProps ||
    !buyBoxProps["cms-ml-buy-box-list"] ||
    buyBoxProps["cms-ml-buy-box-list"].length === 0;

  let hideBannerInMobile = false;
  if (
    bannerProps &&
    (bannerProps.mobileHide === true || bannerProps.mobileHide === "true")
  ) {
    hideBannerInMobile = true;
  }

  return (
    <section id={blockName || ""} className="container product-info">
      <div className={cssProductInfo}>
        <div
          className={`product-info-imagen${
            hideBannerInMobile ? " mobile-hide" : ""
          }`}
        >
          <Banner {...bannerProps} cmsHandler={cmsHandler} />
        </div>
        <div className="product-info-details">
          {(thereIsPageSelector || cmsHandler) && (
            <PageSelector
              {...selectorProps}
              alias={alias}
              blockName={blockName}
              cmsHandler={cmsHandler}
            />
          )}
          <BuyBox
            loaded={loaded}
            cmsHandler={cmsHandler}
            alias={alias}
            blockName={blockName}
            CmsEditableGroupIcons={CmsEditableGroupIcons}
            {...buyBoxProps}
          />
          {alertProps?.["cms-atom-text-2"]?.text ||
          alertProps?.["cms-atom-text-1"]?.text ||
          cmsHandler ? (
            <>
              {thereIsAlert && (
                <hr className="product-info--separator" aria-hidden="true" />
              )}
              <Alert {...alertProps} cmsHandler={cmsHandler} />
            </>
          ) : null}
          {thereIsCharacs && !thereIsNOBuyBox && (
            <hr className="product-info--separator" aria-hidden="true" />
          )}
          <Characteristics
            {...characteristicsProps}
            alias={alias}
            blockName={blockName}
            cmsHandler={cmsHandler}
            CmsAddElement={CmsAddElement}
            CmsEditableGroupIcons={CmsEditableGroupIcons}
          />
        </div>
      </div>
      <style jsx>{`.product-info {
  background-color: white;
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
  .ProductInfo {
    width: 100%;
    display: flex;
    gap: 4rem;
    justify-content: space-between;
    .product-info-imagen {
      flex: 1;
    }
    .product-info-details {
      width: 48%;
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    .product-info--separator {
      color: rgb(221, 221, 221);
    }
    @media screen and (max-width: 768px) {
      flex-direction: column;
      gap: 1rem;
      .product-info-details {
        width: 100%;
      }
      .product-info-imagen.mobile-hide {
        display: none;
      }
    }
  }
}
`}</style>
    </section>
  );
}

CmsProductInfo.propTypes = {};

CmsProductInfo.defaultProps = {};

export default CmsProductInfo;
